"use client";
import { icon, parse } from "@fortawesome/fontawesome-svg-core";
import React from "react";
import convert from "./utils/converter.js"; // Added import for 'convertCurry'
// Import classList function from the appropriate location
import classList from "./utils/get-class-list-from-props.js";
import log from "./utils/logger.js";
import normalizeIconArgs from "./utils/normalize-icon-args.js";
import objectWithKey from "./utils/object-with-key.js";
const convertCurry = convert.bind(null, React.createElement);
const FontAwesomeIcon = React.forwardRef((props, ref) => {
    const { icon: iconArgs, mask: maskArgs, symbol, className = "", // Set a default value for className
    title, titleId, maskId, ...restProps // Capture any other props
     } = props;
    const iconLookup = normalizeIconArgs(iconArgs);
    // Convert boolean props to strings
    const booleanPropToString = (propName, propValue) => {
        return typeof propValue === "boolean" ? propValue.toString() : propValue;
    };
    const classes = objectWithKey("classes", [
        ...(classList(props) || []), // Use the spread operator with nullish coalescing
        ...className.split(" "),
    ]);
    const transform = objectWithKey("transform", typeof props.transform === "string"
        ? parse.transform(props.transform)
        : props.transform);
    const mask = objectWithKey("mask", normalizeIconArgs(maskArgs));
    const renderedIcon = icon(iconLookup, {
        ...classes,
        ...transform,
        ...mask,
        symbol,
        title,
        titleId,
        maskId,
    });
    if (!renderedIcon) {
        log("Could not find icon", iconLookup);
        return null;
    }
    const { abstract } = renderedIcon;
    const extraProps = { ...restProps, ref }; // Use the spread operator
    // Convert boolean props to strings in the extraProps
    Object.keys(restProps).forEach((key) => {
        if (!Object.hasOwn(restProps, key)) {
            extraProps[key] = booleanPropToString(key, restProps[key]);
        }
    });
    return convertCurry(abstract[0], extraProps);
});
FontAwesomeIcon.displayName = "FontAwesomeIcon";
export default FontAwesomeIcon;
//# sourceMappingURL=reactFontAwesome.js.map